import simplebar from './utilities/simplebar-init';
import lenis from './utilities/lenis-init';
import scrollAnimation from './utilities/scroll-animation';
import videoPlayer from './partials/video-player';

const App = {
    init: () => {
        simplebar.init();
        lenis.init();
        videoPlayer.init();

        console.log('App initialized');
    },
    load: () => {
        scrollAnimation.init();

        console.log('App loaded');
    }
}

document.addEventListener('DOMContentLoaded', App.init);
window.addEventListener('load', App.load);